import { Warrior } from '~/../api/common.types';
import {
  getCurrentWarrior,
} from '~/utils/utils';

// interface sortedResponse {
//   fallen: Warrior[] | [];
//   champions: Warrior[] | [];
//   peaceFall: Warrior[] | [];
// }

// function sortWarriorsByTournament(warriors: Warrior[]): sortedResponse {
//   const fallen = warriors.filter((warrior) => !isAliveWarrior(warrior));
//   const champions = warriors.filter(
//     (warrior) => isAliveWarrior(warrior) && warriorByLevel(warrior, 5)
//   );
//   const peaceFall = warriors.filter(
//     (warrior) => isAliveWarrior(warrior) && !warriorByLevel(warrior, 5)
//   );
//   return {
//     fallen,
//     champions,
//     peaceFall,
//   };
// }

function WarriorItem({
  warrior,
}: {
  warrior: Warrior;
}) {
  const warriorData = getCurrentWarrior(warrior);

  return (
    <button className="grid__item grid__item--static">
      <img
        src={warriorData.dead ? warriorData.images.dead : warriorData.images.notActive}
        alt={warriorData.name}
      />
      <h4>{warriorData.name}</h4>
      <p>
        Level {warriorData.level}, HP {warriorData.hp}, Type {warriorData.type},
        Syndicate {warriorData.syndicate}
      </p>
    </button>
  );
}

export function WarriorsByTournament({ warriors, registered }: { warriors: Warrior[], registered?: boolean }) {
  // const tournaments = sortWarriorsByTournament(warriors);
  let message = warriors.length === 1 ? 'Warrior' : 'Warriors';
  message = registered ? `Registered ${message}` : `Eligible ${message}`;
  return (
    <>
      <h2 className="hd-keyline">{warriors.length} {message}</h2>
      {/* <h3 className="revival-headline">
      ({warriors.length} Eligible)
      </h3> */}
      {warriors.length ? (
        <div className="grid-revive-warriors">
          {warriors.map((warrior, i) => (
            <WarriorItem warrior={warrior} key={i} />
          ))}
        </div>
      ) : (
        <div className="grid-potions__text grid-potions__explainer">
          You do not have any Warriors eligible for the Tournaments
        </div>
      )}
    </>
  );
}
